import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
export default class MundialTaldezainaPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "saving", false);
    _defineProperty(this, "teams", []);
    // Track points edits locally before saving
    _defineProperty(this, "editedPoints", {});
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    this.loadData();
  }
  loadData() {
    this.loading = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/mundial-teams'
    }).then(response => {
      this.teams = app.store.pushPayload(response) || [];
      this.teams.forEach(t => {
        this.editedPoints[parseInt(t.id())] = t.attribute('points') || 0;
      });
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  handlePointsChange(teamId, val) {
    const points = parseInt(val) || 0;
    this.editedPoints[teamId] = points;
  }
  saveAll() {
    this.saving = true;
    const teamsPayload = Object.keys(this.editedPoints).map(id => ({
      id: parseInt(id),
      points: this.editedPoints[parseInt(id)]
    }));
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/mundial-teams/update',
      body: {
        data: {
          attributes: {
            teams: teamsPayload
          }
        }
      }
    }).then(() => {
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, 'Puntos guardados con éxito. Puntuaciones de los foreros actualizadas.');
      window.location.reload();
    }).catch(() => {
      this.saving = false;
      m.redraw();
    });
  }
  view() {
    if (!this.canManage) return null;
    if (this.loading) {
      return m("div", {
        className: "GorbeaTaldezainaPage"
      }, m("div", {
        className: "container",
        style: "padding: 40px; text-align: center;"
      }, m(LoadingIndicator, null)));
    }
    const pot1Teams = this.teams.filter(t => t.attribute('pot') === 1);
    const pot2Teams = this.teams.filter(t => t.attribute('pot') === 2);
    const pot3Teams = this.teams.filter(t => t.attribute('pot') === 3);
    const pot4Teams = this.teams.filter(t => t.attribute('pot') === 4);
    return m("div", {
      className: "GorbeaTaldezainaPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), "Volver a Taldezaina")), m("div", {
      className: "EditRival-header",
      style: "margin-bottom: 40px; display: flex; align-items: center; gap: 20px;"
    }, m("div", {
      style: "height: 70px; width: 70px; border-radius: 12px; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; border: 2px solid rgba(255, 255, 255, 0.1);"
    }, m("i", {
      className: "fas fa-trophy",
      style: "font-size: 2.2rem; color: var(--heading-color);"
    })), m("div", null, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, "Taldezaina - Porrita Mundial 2026"), m("p", {
      style: "color: var(--muted-color); font-size: 1.2em; margin-top: 4px;"
    }, "Gestiona los puntos de cada selecci\xF3n y recalculado de foreros."))), m("div", {
      style: "background: rgba(255, 193, 7, 0.08); border: 1px solid rgba(255, 193, 7, 0.25); border-radius: 16px; padding: 25px; margin-bottom: 35px; color: var(--text-color);"
    }, m("h4", {
      style: "font-weight: bold; margin: 0 0 12px 0; display: flex; align-items: center; gap: 8px; color: #ffc107;"
    }, m("i", {
      className: "fas fa-info-circle"
    }), " BASES PARA ESTABLECER LOS PUNTOS DE LAS SELECCIONES"), m("ul", {
      style: "margin: 0; padding-left: 20px; line-height: 1.6;"
    }, m("li", null, m("strong", null, "+1 punto"), " por cada punto en fase de grupos."), m("li", null, m("strong", null, "+3 puntos"), " por cada fase superada (pasar la fase de grupos es +3, y cada eliminatoria de octavos, cuartos, semifinales, etc., suma +3 adicionales)."), m("li", null, m("strong", null, "+10 puntos"), " al Campe\xF3n del Mundial."), m("li", null, m("strong", null, "+6 puntos"), " al Subcampe\xF3n del Mundial."), m("li", null, m("strong", null, "+3 puntos"), " al Tercero y Cuarto clasificados del Mundial."), m("li", null, m("strong", null, "+3 puntos"), " al m\xE1ximo Goleador del Mundial (si es compartido, se da a ambas selecciones)."), m("li", null, m("strong", null, "+3 puntos"), " al MVP de la final."))), m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 25px; margin-bottom: 35px;"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 20px 0; color: var(--heading-color); border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 10px;"
    }, "\u26BD Selecciones del Mundial y Puntos"), [1, 2, 3, 4].map(potNum => {
      const potTeams = potNum === 1 ? pot1Teams : potNum === 2 ? pot2Teams : potNum === 3 ? pot3Teams : pot4Teams;
      return m("div", {
        style: "margin-bottom: 30px;"
      }, m("h4", {
        style: "font-weight: 800; font-size: 1.1em; color: var(--heading-color); margin-bottom: 15px; border-left: 3px solid #EE2523; padding-left: 10px;"
      }, "Bombo ", potNum), m("div", {
        style: "display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 15px;"
      }, potTeams.map(team => {
        const teamId = parseInt(team.id());
        return m("div", {
          style: "display: flex; align-items: center; justify-content: space-between; padding: 12px 15px; background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.05); border-radius: 10px;"
        }, m("span", {
          style: "font-weight: 500; font-size: 1.05em; margin-right: 10px;"
        }, team.name()), m("div", {
          style: "display: flex; align-items: center; gap: 6px;"
        }, m("button", {
          type: "button",
          className: "Button",
          style: "padding: 2px 8px; border-radius: 4px; border: 1px solid rgba(255,255,255,0.15); background: #EE2523; color: #fff; font-weight: bold;",
          onclick: () => {
            const current = this.editedPoints[teamId] || 0;
            this.editedPoints[teamId] = Math.max(0, current - 1);
          }
        }, "-1"), m("input", {
          type: "number",
          className: "FormControl",
          min: "0",
          value: this.editedPoints[teamId],
          oninput: e => this.handlePointsChange(teamId, e.target.value),
          style: "width: 50px; text-align: center; border-radius: 6px; padding: 4px; margin: 0;"
        }), m("button", {
          type: "button",
          className: "Button",
          style: "padding: 2px 8px; border-radius: 4px; border: 1px solid rgba(255,255,255,0.15); background: #28a745; color: #fff; font-weight: bold;",
          onclick: () => {
            const current = this.editedPoints[teamId] || 0;
            this.editedPoints[teamId] = current + 1;
          }
        }, "+1")));
      })));
    })), m("div", {
      style: "text-align: center;"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.saveAll(),
      loading: this.saving,
      style: "border-radius: 30px; font-weight: bold; padding: 12px 40px; font-size: 1.1em; background: #EE2523; border: none; height: 48px;"
    }, "\uD83D\uDCBE Guardar Puntos y Recalcular Clasificaci\xF3n"))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/mundial/MundialTaldezainaPage', MundialTaldezainaPage);